/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const callStaffTgBotResponseSchema = z.object({
	response_text: z.string(),
});
